import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { ageLibraries } from '../data/bonuses';
import { SectionHeading } from './SectionHeading';

/* One tint per card, in the portal's own palette. */
const tints = [{
  surface: '#FFF9EC',
  badge: '#FFE6A8'
}, {
  surface: '#EFF7F5',
  badge: '#CFE6E0'
}, {
  surface: '#FFF4D9',
  badge: '#FFD873'
}];
export function AgeLibraries() {
  const jumpToSearch = () => {
    const el = document.getElementById('search');
    if (el) el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section aria-label="Explore by age" id="ages" className="scroll-mt-24" data-id="element-22" data-mp="3tcsm5q9do380">
      <SectionHeading index="04" title="Explore by age" note="A second way in, for the afternoon when you do not know where to start. Each library sits alongside the books rather than replacing them." data-id="element-23" data-mp="bz5kmwmqfkj3" />

      <ul className="mt-10 grid gap-5 sm:grid-cols-3" data-id="element-24" data-mp="3fl4cruqijsuq">
        {ageLibraries.map((lib, i) => {
        const tint = tints[i % tints.length];
        return <li key={lib.id} className="flex flex-col rounded-[18px] border border-navy/10 p-6 sm:p-7" style={{
          backgroundColor: tint.surface
        }} data-id="element-25" data-mp="1mkn5s9f5wopp" data-mpi={i}>
              <span className="tnum inline-flex w-fit items-center rounded-full px-3.5 py-1.5 font-display text-[15px] font-semibold text-navy" style={{
            backgroundColor: tint.badge
          }} data-id="element-26" data-mp="1wbhqvago9i9k">
                Ages {lib.band}
              </span>

              <h3 className="mt-5 font-display text-[20px] font-semibold leading-tight text-navy" data-id="element-27" data-mp="18m6nrmbunbs9">
                {lib.title}
              </h3>
              <p className="mt-2 font-sans text-[14.5px] leading-relaxed text-navy/70" data-id="element-28" data-mp="1cpblzcowcrb3">
                {lib.blurb}
              </p>

              <div className="mt-auto flex flex-wrap gap-2 pt-6" data-id="element-29" data-mp="2o2xaqwqugqw3">
                <a href={lib.href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-[12px] bg-navy px-4 py-2.5 font-sans text-[13px] font-medium text-paper transition-colors duration-150 ease-out hover:bg-[#0A2440] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-paper" data-id="element-30" data-mp="2t18mxe4m3dhh">
                  <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={2} data-id="element-31" data-mp="xyvdtgv2um9v" />
                  Open library
                </a>
                {lib.filter.length ? <button type="button" onClick={jumpToSearch} className="inline-flex items-center gap-2 rounded-[12px] border border-navy/25 px-4 py-2.5 font-sans text-[13px] font-medium text-navy transition-colors duration-150 ease-out hover:border-navy/50 hover:bg-white/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-paper" data-id="element-32" data-mp="5azmkroa1mkh">
                    Projects for this age
                  </button> : null}
              </div>
            </li>;
      })}
      </ul>
    </section>;
}